module.exports = __webpack_public_path__ + "img/face18.c763703f.gif";